<template>
  <div class="HeatTreatmentAnalysis">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <b-col cols="12" class="px-5 mb-1">
          <div ref="test">
            <b-col
              cols="12"
              class="p-0 m-0 mt-4"
              style="font-size: 1.75rem; color: #000000"
            >
              <span class="m-auto">統計分析</span>
            </b-col>

            <b-col cols="12" class="mx-0" style="margin-top: 2rem">
              <b-row>
                <commonQueryIoT />
              </b-row>
            </b-col>

            <b-col cols="12" class="mt-4 d-flex justify-content-between">
              <span>資料筆數： {{ dataCount.toLocaleString("en-US") }}</span>
              <exportCsv />
            </b-col>
          </div>
        </b-col>
        <b-col cols="12" class="mb-3">
          <div style="padding: 0 50px;">
            <div style="overflow: auto;height: 660px;">
              <!-- calc(100vh - 60px - 240px) -->
              <div style="display: flex;">
                <div
                  v-for="(item, key) in heatTreatmentAnalysisData"
                  :key="key"
                  class="ht-sensor-area"
                >
                  <table class="ht-analysis-table">
                    <thead>
                      <tr>
                        <th
                          :colspan="item.startTime.length + 1"
                          class="font-family-dfyuanstd-w5"
                          style="background-color: #4b8c80;color:#ffffff;"
                        >
                          {{ item.name }}
                        </th>
                      </tr>
                      <tr>
                        <th class="font-family-dfyuanstd-w5">
                          開始時間
                        </th>
                        <th
                          v-for="(startTimeItem,
                          startTimeKey) in item.startTime"
                          :key="startTimeKey"
                          class="font-family-dfyuanstd-w5"
                        >
                          {{ startTimeItem }}
                        </th>
                      </tr>
                      <tr>
                        <th class="font-family-dfyuanstd-w5">
                          結束時間
                        </th>
                        <th
                          v-for="(endTimeItem, endTimeKey) in item.endTime"
                          :key="endTimeKey"
                          class="font-family-dfyuanstd-w5"
                        >
                          {{ endTimeItem }}
                        </th>
                      </tr>
                      <tr
                        style="color:#4b8c80;background-color: rgba(0, 177, 82, 0.1);"
                      >
                        <th class="font-family-dfyuanstd-w5">
                          設定值
                        </th>
                        <th
                          v-for="(setValueItem, setValueKey) in item.setValue"
                          :key="setValueKey"
                          class="font-family-dfyuanstd-w5"
                          :class="{ warning: setValueItem == '-' }"
                        >
                          <!-- warning:設定值等於'-'顯示 異常顏色 -->
                          {{ setValueItem.toLocaleString("en-US") }}
                        </th>
                      </tr>
                      <tr>
                        <th class="font-family-dfyuanstd-w5">
                          實際值小計
                        </th>
                        <th
                          v-for="(actValueCountItem,
                          actValueCountKey) in item.actValueCount"
                          :key="actValueCountKey"
                          class="font-family-dfyuanstd-w5"
                        >
                          {{ actValueCountItem.toLocaleString("en-US") }}
                        </th>
                      </tr>
                      <tr>
                        <th class="font-family-dfyuanstd-w5">
                          實際值
                        </th>
                        <th
                          v-for="n in item.setValue.length"
                          :key="n"
                          class="font-family-dfyuanstd-w5"
                        >
                          資料筆數
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="(actErrorValueObjectItem,
                        actErrorValueObjectKey) in item.actErrorValueObject"
                      >
                        <tr>
                          <td>
                            {{ actErrorValueObjectKey }}
                          </td>
                          <td
                            v-for="(actErrorValueObjectItemValue,
                            actErrorValueObjectItemIndex) in actErrorValueObjectItem"
                            :key="actErrorValueObjectItemIndex"
                            :class="{
                              warning: actErrorValueObjectItemValue != 0
                            }"
                          >
                            <!-- warning:實際值數量不等於0 顯示 異常顏色 -->
                            <template v-if="actErrorValueObjectItemValue != 0">
                              {{
                                actErrorValueObjectItemValue.toLocaleString(
                                  "en-US"
                                )
                              }}
                            </template>
                          </td>
                        </tr>
                      </template>
                      <template
                        v-for="(actValueObjectItem,
                        actValueObjectKey) in item.actValueObject"
                      >
                        <tr>
                          <template v-if="item.type == 'cp'">
                            <template v-if="actValueObjectKey == '0'">
                              <td>
                                0
                              </td>
                            </template>
                            <template v-else-if="actValueObjectKey == '0.19'">
                              <td>
                                0.001~0.199
                              </td>
                            </template>
                            <template v-else-if="actValueObjectKey == '0.50'">
                              <td>
                                0.50~
                              </td>
                            </template>
                            <template v-else>
                              <td>
                                {{
                                  Number(actValueObjectKey).toFixed(2) +
                                    "~" +
                                    (Number(actValueObjectKey) + 0.009).toFixed(
                                      3
                                    )
                                }}
                              </td>
                            </template>
                          </template>
                          <template v-else-if="item.type == 'other'">
                            <td>
                              {{ actValueObjectKey.toLocaleString("en-US") }}
                            </td>
                          </template>
                          <td
                            v-for="(actValueObjectItemValue,
                            actValueObjectItemIndex) in actValueObjectItem"
                            :key="actValueObjectItemIndex"
                            :class="{
                              highlighting:
                                item.setValue[actValueObjectItemIndex] != '-' &&
                                (actValueObjectKey ==
                                  item.setValue[actValueObjectItemIndex] ||
                                  actValueObjectKey ==
                                    item.setValue[
                                      actValueObjectItemIndex
                                    ].toFixed(2)),
                              warning:
                                actValueObjectItemValue != 0 &&
                                (item.setValue[actValueObjectItemIndex] ==
                                  '-' ||
                                  (item.setValue[actValueObjectItemIndex] !=
                                    '-' &&
                                    ((item.type == 'other' &&
                                      (item.setValue[actValueObjectItemIndex] +
                                        10 <
                                        actValueObjectKey ||
                                        item.setValue[actValueObjectItemIndex] -
                                          10 >
                                          actValueObjectKey)) ||
                                      (item.type == 'cp' &&
                                        (Number(
                                          (
                                            item.setValue[
                                              actValueObjectItemIndex
                                            ] + 0.05
                                          ).toFixed(2)
                                        ) < actValueObjectKey ||
                                          Number(
                                            (
                                              item.setValue[
                                                actValueObjectItemIndex
                                              ] - 0.05
                                            ).toFixed(2)
                                          ) > actValueObjectKey)))))
                            }"
                          >
                            <!-- highlighting:設定值不等於'-' && 設定值等於實際值 顯示 醒目顏色 -->
                            <!-- warning:實際值數量不等於0 && (設定值等於'-' || 實際值等於'-' || 實際值超過異常門檻) 顯示 異常顏色 -->
                            <template v-if="actValueObjectItemValue != 0">
                              {{
                                actValueObjectItemValue.toLocaleString("en-US")
                              }}
                            </template>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import exportCsv from "@/components/exportCsv.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "HeatTreatmentAnalysis",
  data() {
    return {
      dataCount: 0,
      heatTreatmentAnalysisData: [
        // {
        //   name: "焠火5區",
        //   type: "other",
        //   startTime: ["00:00:00", "10:20:30"],
        //   endTime: ["10:20:00", "23:59:30"],
        //   setValue: [850, 860],
        //   actValueObject: {
        //     840: [1, 3],
        //     850: [2, 3],
        //     830: [1, 0],
        //     860: [1, 3]
        //   }
        // },
        // {
        //   name: "碳勢",
        //   type: "cp",
        //   startTime: ["00:00:00", "10:20:30"],
        //   endTime: ["10:20:00", "23:59:30"],
        //   setValue: [0.33, 0.32],
        //   actValueObject: {
        //     0.3: [1, 0],
        //     0.31: [1, 0],
        //     0.32: [1, 3],
        //     0.33: [2, 3],
        //     0.34: [2, 3],
        //     0.35: [1, 3]
        //   }
        // }
      ],
      exportData: {}
    };
  },
  created: function() {
    let vm = this;
    vm.setCommonQueryData();
    vm.setQueryInput();
  },
  mounted: function() {
    let vm = this;
  },
  components: {
    commonQueryIoT,
    exportCsv
  },
  watch: {
    commonQueryResponse: {
      handler() {
        let vm = this;
        if (
          vm.commonQueryResponse == "查無資料" ||
          vm.commonQueryResponse == "時間尚未選擇"
        ) {
          vm.reset([]);
          return;
        }
        vm.dataCount = vm.commonQueryResponse.data_count;
        vm.heatTreatmentAnalysisData = vm.commonQueryResponse.analysis_data;
        vm.exportData = {
          date: vm.commonQueryResponse.date,
          device_name: vm.commonQueryResponse.device_name,
          data_title: vm.commonQueryResponse.data_title,
          raw_data_title: vm.commonQueryResponse.raw_data_title,
          raw_data: vm.commonQueryResponse.raw_data
        };
        vm.setExportExcelData();
      }
    }
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      commonQueryResponse: "commonqueryiot/get_queryResponse"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_exportExcelFileName: "exportcsv/set_exportExcelFileName",
      set_exportExcelData: "exportcsv/set_exportExcelData"
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("AnalysisQuery");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        startTime: true,
        endTime: false,
        startMinTime: false,
        endMinTime: false,
        htProcess: true,
        deviceCode: true,
        workCode: false
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: false,
        startMinTime: false,
        endMinTime: false,
        process: false,
        htProcess: true,
        deviceCode: true,
        productCode: false,
        workCode: false
      });
    },
    //清空熱處理匯出相關資料
    clearExportCsv() {
      let vm = this;
      vm.set_exportExcelData([]);
      vm.set_exportExcelFileName("");
    },
    //熱處理參數匯出
    setExportExcelData() {
      let vm = this;
      let heatTreatmentAnalysisData = vm.heatTreatmentAnalysisData;
      if (heatTreatmentAnalysisData.length == 0) {
        vm.clearExportCsv();
        return;
      }
      let exportData = vm.exportData;
      let date = exportData.date;
      let device_name = exportData.device_name;
      let data_title = exportData.data_title; // 時間與日期
      let raw_data_title = exportData.raw_data_title;
      let raw_data = exportData.raw_data;
      let fileName = "熱處理統計分析_" + device_name + "_" + date;

      let itemData = [[], [], [], [], [], [], []]; // [感測器標題, 開始時間, 結束時間, 設定值, 實際值小計, 實際值, 異常實際值, 感測器各個實際值...]
      let merge = [];
      let col = [];
      let borderStyle = {
        top: {
          style: "thin",
          color: { rgb: "999999" }
        },
        bottom: {
          style: "thin",
          color: { rgb: "999999" }
        },
        left: {
          style: "thin",
          color: { rgb: "999999" }
        },
        right: {
          style: "thin",
          color: { rgb: "999999" }
        }
      };
      let excelStyle = {
        // 指定行數的樣式(包含fields欄)
        // R: {
        //   1: {// 第一行
        //     font: {// 文字
        //       color: { rgb: "ffffff" }
        //     },
        //     fill: {// 背景
        //       fgColor: { rgb: "4b8c80" }
        //     }
        //   }
        // }
        R: {
          1: {
            font: {
              // name: "標楷體",
              color: { rgb: "ffffff" }
            },
            fill: {
              fgColor: { rgb: "4b8c80" }
            }
          },
          4: {
            font: {
              // name: "標楷體",
              color: { rgb: "4b8c80" }
            },
            fill: {
              fgColor: { rgb: "e5f7ed" }
            },
            border: {
              top: {
                style: "thin",
                color: { rgb: "999999" }
              },
              bottom: {
                style: "thick",
                color: { rgb: "999999" }
              },
              left: {
                style: "thin",
                color: { rgb: "999999" }
              },
              right: {
                style: "thin",
                color: { rgb: "999999" }
              }
            }
          }
        },
        //指定欄數的樣式
        C: {},
        common: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          },
          font: {
            // name: "標楷體"
          },
          border: borderStyle
        },
        detail: {
          // "12-1": {
          //   // R-C('行數-欄數')
          //   font: {
          //     name: "標楷體",
          //     color: { rgb: "4b8c80" }
          //   },
          //   fill: {
          //     fgColor: { rgb: "e5f7ed" }
          //   }
          // }
        }
      };
      let maxActValueArraylength = 0;
      heatTreatmentAnalysisData.forEach(data => {
        let actValueArraylength = Object.keys(data.actValueObject).length;
        if (maxActValueArraylength < actValueArraylength) {
          maxActValueArraylength = actValueArraylength;
        }
      });
      // 新增最大位置
      for (let i = 0; i < maxActValueArraylength; i++) {
        itemData.push([]);
      }
      heatTreatmentAnalysisData.forEach((data, index) => {
        merge.push({
          s: { r: 1, c: itemData[0].length },
          e: { r: 1, c: itemData[0].length + data.setValue.length }
        });
        col.push({ wch: 15 });
        // 感測器標題
        itemData[0].push(data.name);
        // 設定值
        itemData[3].push("設定值");
        for (let i = 0; i < data.setValue.length; i++) {
          col.push({ wch: 15 });
          itemData[0].push("");
          if (data.setValue[i] == "-") {
            excelStyle.detail["4-" + itemData[3].length] = {
              fill: {
                fgColor: { rgb: "ffc100" }
              }
            };
          }
          itemData[3].push(data.setValue[i]);
        }
        col.push({ wch: 3 });
        excelStyle.C[itemData[0].length] = null;
        itemData[0].push("");
        itemData[3].push("");
        // 開始時間
        itemData[1].push("開始時間");
        for (let i = 0; i < data.startTime.length; i++) {
          itemData[1].push(data.startTime[i]);
        }
        itemData[1].push("");
        // 結束時間
        itemData[2].push("結束時間");
        for (let i = 0; i < data.endTime.length; i++) {
          itemData[2].push(data.endTime[i]);
        }
        itemData[2].push("");
        // 實際值小計
        itemData[4].push("實際值小計");
        for (let i = 0; i < data.actValueCount.length; i++) {
          itemData[4].push(data.actValueCount[i]);
        }
        itemData[4].push("");
        // 實際值
        itemData[5].push("實際值");
        for (let i = 0; i < data.setValue.length; i++) {
          itemData[5].push("資料筆數");
        }
        itemData[5].push("");

        // 實際異常值數量
        let actErrorValueArray = Object.keys(data.actErrorValueObject);
        // 實際值數量
        let actValueArray = Object.keys(data.actValueObject);
        let sensorPosition = itemData[3].length - 1 - data.setValue.length;
        if (actErrorValueArray.length != 0) {
          for (let i = 0; i < actErrorValueArray.length; i++) {
            // 將實際值依照順序填入
            let thisActErrorValue = actErrorValueArray[i]; // 該行實際值
            if (thisActErrorValue == "-") {
              itemData[6 + i].push("-");
            } else {
              thisActErrorValue = Number(thisActErrorValue);
              itemData[6 + i].push(thisActErrorValue);
            }
            for (
              let j = 0;
              j < data.actErrorValueObject[actErrorValueArray[i]].length;
              j++
            ) {
              // 實際值超出設定值範圍，上異常顏色
              if (data.actErrorValueObject[actErrorValueArray[i]][j] != 0) {
                excelStyle.detail[6 + i + 1 + "-" + (sensorPosition + j)] = {
                  fill: {
                    fgColor: { rgb: "ffc100" }
                  }
                };
              }
              // 若實際值的數量為0，則不填入值
              if (data.actErrorValueObject[actErrorValueArray[i]][j] == 0) {
                itemData[6 + i].push("");
              } else {
                itemData[6 + i].push(
                  data.actErrorValueObject[actErrorValueArray[i]][j]
                );
              }
            }
            itemData[6 + i].push("");
          }
        }
        if (data.type == "cp") {
          for (let i = 0; i < actValueArray.length; i++) {
            // 將實際值依照順序填入
            let thisActValue = actValueArray[i]; // 該行實際值
            thisActValue = Number(thisActValue);
            if (thisActValue == 0) {
              itemData[6 + actErrorValueArray.length + i].push(0);
            } else if (thisActValue == 0.19) {
              itemData[6 + actErrorValueArray.length + i].push("0.001~0.199");
            } else if (thisActValue == 0.5) {
              itemData[6 + actErrorValueArray.length + i].push("0.50~");
            } else {
              itemData[6 + actErrorValueArray.length + i].push(
                thisActValue.toFixed(2) +
                  "~" +
                  (thisActValue + 0.009).toFixed(3)
              );
            }
            for (
              let j = 0;
              j < data.actValueObject[actValueArray[i]].length;
              j++
            ) {
              if (itemData[3][sensorPosition + j] == "-") {
                //設定值為-時，且實際值的數量不為0，上異常顏色
                if (data.actValueObject[actValueArray[i]][j] != 0) {
                  excelStyle.detail[
                    6 +
                      actErrorValueArray.length +
                      i +
                      1 +
                      "-" +
                      (sensorPosition + j)
                  ] = {
                    fill: {
                      fgColor: { rgb: "ffc100" }
                    }
                  };
                }
              } else {
                // 確認與設定值相同的欄位上色
                if (
                  thisActValue ==
                  Number(itemData[3][sensorPosition + j].toFixed(2))
                ) {
                  excelStyle.detail[
                    6 +
                      actErrorValueArray.length +
                      i +
                      1 +
                      "-" +
                      (sensorPosition + j)
                  ] = {
                    font: {
                      // name: "標楷體",
                      color: { rgb: "4b8c80" }
                    },
                    fill: {
                      fgColor: { rgb: "e5f7ed" }
                    }
                  };
                }
                // 實際值超出設定值範圍，上異常顏色
                if (
                  data.actValueObject[actValueArray[i]][j] != 0 &&
                  (Number((itemData[3][sensorPosition + j] + 0.05).toFixed(2)) <
                    thisActValue ||
                    Number(
                      (itemData[3][sensorPosition + j] - 0.05).toFixed(2)
                    ) > thisActValue)
                ) {
                  excelStyle.detail[
                    6 +
                      actErrorValueArray.length +
                      i +
                      1 +
                      "-" +
                      (sensorPosition + j)
                  ] = {
                    fill: {
                      fgColor: { rgb: "ffc100" }
                    }
                  };
                }
              }
              // 若實際值的數量為0，則不填入值
              if (data.actValueObject[actValueArray[i]][j] == 0) {
                itemData[6 + actErrorValueArray.length + i].push("");
              } else {
                itemData[6 + actErrorValueArray.length + i].push(
                  data.actValueObject[actValueArray[i]][j]
                );
              }
            }
            itemData[6 + actErrorValueArray.length + i].push("");
          }
        } else if (data.type == "other") {
          for (let i = 0; i < actValueArray.length; i++) {
            // 將實際值依照順序填入
            let thisActValue = actValueArray[i]; // 該行實際值
            thisActValue = Number(thisActValue);
            itemData[6 + actErrorValueArray.length + i].push(thisActValue);
            for (
              let j = 0;
              j < data.actValueObject[actValueArray[i]].length;
              j++
            ) {
              if (itemData[3][sensorPosition + j] == "-") {
                //設定值為-時，且實際值的數量不為0，上異常顏色
                if (data.actValueObject[actValueArray[i]][j] != 0) {
                  excelStyle.detail[
                    6 +
                      actErrorValueArray.length +
                      i +
                      1 +
                      "-" +
                      (sensorPosition + j)
                  ] = {
                    fill: {
                      fgColor: { rgb: "ffc100" }
                    }
                  };
                }
              } else {
                // 確認與設定值相同的欄位上色
                if (thisActValue == itemData[3][sensorPosition + j]) {
                  excelStyle.detail[
                    6 +
                      actErrorValueArray.length +
                      i +
                      1 +
                      "-" +
                      (sensorPosition + j)
                  ] = {
                    font: {
                      // name: "標楷體",
                      color: { rgb: "4b8c80" }
                    },
                    fill: {
                      fgColor: { rgb: "e5f7ed" }
                    }
                  };
                }
                // 實際值超出設定值範圍，上異常顏色
                if (
                  data.actValueObject[actValueArray[i]][j] != 0 &&
                  (itemData[3][sensorPosition + j] + 10 < thisActValue ||
                    itemData[3][sensorPosition + j] - 10 > thisActValue)
                ) {
                  excelStyle.detail[
                    6 +
                      actErrorValueArray.length +
                      i +
                      1 +
                      "-" +
                      (sensorPosition + j)
                  ] = {
                    fill: {
                      fgColor: { rgb: "ffc100" }
                    }
                  };
                }
              }
              // 若實際值的數量為0，則不填入值
              if (data.actValueObject[actValueArray[i]][j] == 0) {
                itemData[6 + actErrorValueArray.length + i].push("");
              } else {
                itemData[6 + actErrorValueArray.length + i].push(
                  data.actValueObject[actValueArray[i]][j]
                );
              }
            }
            itemData[6 + actErrorValueArray.length + i].push("");
          }
        }
        // 補到最大長度
        for (
          let i = 0;
          i <
          itemData.length -
            6 -
            actErrorValueArray.length -
            actValueArray.length;
          i++
        ) {
          let thisSupKey =
            6 + actErrorValueArray.length + actValueArray.length + i; // 前面固定6行
          excelStyle.detail[thisSupKey + 1 + "-" + (sensorPosition - 1)] = null;
          itemData[thisSupKey].push("");
          for (let j = 0; j < data.setValue.length; j++) {
            excelStyle.detail[
              thisSupKey + 1 + "-" + (sensorPosition + j)
            ] = null;
            itemData[thisSupKey].push("");
          }
          itemData[thisSupKey].push("");
        }
      });

      let setExportData = [];
      let exportAnalysisObj = {
        sheetName: "數據分析結果",
        title: data_title,
        data: itemData,
        merge: merge,
        col: col,
        excelStyle: excelStyle
      };
      setExportData.push(exportAnalysisObj);

      let exportRawObj = {
        sheetName: "raw data",
        title: raw_data_title,
        data: raw_data
      };
      setExportData.push(exportRawObj);

      if (setExportData.length == 0) {
        vm.set_exportExcelData([]);
        vm.set_exportExcelFileName();
      } else {
        vm.set_exportExcelData(setExportData);
        vm.set_exportExcelFileName(fileName);
      }
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    let vm = this;
    vm.clearExportCsv();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.ht-analysis-table th,
.ht-analysis-table td {
  height: 2.5rem;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-width: 1px !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
  min-width: 125px;
}
.ht-analysis-table th:first-child,
.ht-analysis-table td:first-child {
  border-left: 1px solid;
}
.ht-analysis-table {
  margin-bottom: 0px;
}
.ht-analysis-table thead tr:nth-last-child(2) {
  border-top: 3px solid #999999;
}
.ht-sensor-area {
  margin-right: 1rem;
}
.ht-sensor-area:last-child {
  margin-right: 0;
}
.ht-analysis-table .highlighting {
  color: #4b8c80;
  background-color: rgba(0, 177, 82, 0.1);
}
.ht-analysis-table .warning {
  color: #000;
  background-color: #ffc100;
}
</style>



// WEBPACK FOOTER //
// src/components/heatTreatmentAnalysis.vue